<template>
    <div>
        <div class="bg-light relative flex flex-wrap sm:items-end sm:justify-between py-6 px-8">
            <button @click="handleClose" type="button" class="absolute top-0 right-0 text-gray-600 hover:text-gray-700 mt-4 mr-6 py-1 px-2">
                <i class="far fa-times fa-lg"></i>
            </button>

            <div class="text-center sm:text-left">
                <h4 class="text-xl sm:text-2xl font-semibold mb-0">
                    <i class="fad fa-user-unlock mr-2"></i>
                    Signup
                    <span class="text-muted mx-1">or</span>
                    <a @click.prevent="changeForm('login')" href="javascript:void(0)">
                        Login
                    </a>
                </h4>

                <h5 class="text-base text-muted mb-0 mt-3">
                    Find the most popular products online
                    <!-- Discover popular products online -->
                </h5>
            </div>
        </div>

        <div class="p-8">
            <div class="flex justify-center">
                <div class="w-full sm:w-8/12">
                    <a href="/auth/discord" class="mb-2 btn btn-dark btn-block btn-lg btn-discord font-semibold" style="border-width: 2px; border-color: #4a63c8; color: #fff; background-color: #5c7cfa;">
                        <i class="fab fa-discord mr-1"></i>
                        Signup with Discord
                    </a>

                    <!-- @todo facebook -->
                    <!-- @todo twitter -->

                    <a href="/auth/google" class="mb-2 btn btn-light btn-block btn-lg font-semibold" style="border-width: 2px; border-color: #767676; color: #333; background-color: #fff;">
                        <i class="fab fa-google mr-1"></i>
                        Signup with Google
                    </a>
                </div>
            </div>

            <div class="divider-text">or</div>

            <form action="/register" method="POST">
                <!-- @todo csrf -->

                <div class="form-group sm:flex sm:justify-center">
                    <label for="name" class="w-full sm:w-4/12 col-form-label md:text-right font-semibold pr-0 sm:pr-5">
                        Name
                    </label>

                    <div class="w-full sm:w-6/12">
                        <input type="text" name="name" value="" id="name" class="form-control" required autocomplete="name" autofocus />
                    </div>
                </div>

                <div class="form-group sm:flex sm:justify-center">
                    <label for="email" class="w-full sm:w-4/12 col-form-label md:text-right font-semibold pr-0 sm:pr-5">
                        Email Address
                    </label>

                    <div class="w-full sm:w-6/12">
                        <input type="email" name="email" value="" id="email" class="form-control" required autocomplete="email" />
                    </div>
                </div>

                <div class="form-group sm:flex sm:justify-center">
                    <label for="password" class="w-full sm:w-4/12 col-form-label md:text-right font-semibold pr-0 sm:pr-5">
                        Password
                    </label>

                    <div class="w-full sm:w-6/12">
                        <input type="password" name="password" id="password" class="form-control" required autocomplete="new-password" />
                    </div>
                </div>

                <div class="form-group sm:flex sm:justify-center sm:items-center mb-0">
                    <div class="w-full sm:w-6/12 mt-0 sm:mt-2">
                        <button type="submit" class="btn btn-primary btn-block btn-lg font-semibold text-lg">
                            Create Account
                        </button>
                    </div>

                    <div class="w-full sm:w-2/12 flex flex-no-wrap sm:ml-4 text-center sm:text-left mt-4 sm:mt-0">
                        <span class="mr-2">or</span>
                        <a @click.prevent="changeForm('login')" href="javascript:void(0)">
                            Login
                        </a>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
export default {
    props: [],

    data: () => ({}),

    created() {},

    mounted() {},

    computed: {},

    methods: {
        changeForm(form) {
            this.$emit('changeForm', form);
        },

        handleClose() {
            this.$emit('close');
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
